import { useSelector } from 'react-redux';

import { getIsReimburseViaSepaEnabled } from 'src/core/selectors/globalSelectors';

export const useIsReimburseViaSepaEnabled = () => {
  return useSelector(getIsReimburseViaSepaEnabled);
};
